import React from 'react';
import { Stack, SrOnly } from '@fashionnovateam/nova-ui-toolkit';
import styles from './PageLoading.module.css';

export function PageLoading() {
  return (
    <Stack
      direction="col"
      content="center"
      align="center"
      gap="md"
      className="w-full h-full"
      data-testid="page-loading"
    >
      <div className={styles.loader} />
      <SrOnly>Loading...</SrOnly>
    </Stack>
  );
}
